import React from "react";

import styled from "styled-components";

import messageImg from "./image/message.png";
import organizationImg from "./image/organization.png";
import historyImg from "./image/history.png";
import CertImg from "./image/cert.jpg";

export default function Content(props) {
  const { id } = props;
  const cards = [messageImg, organizationImg, historyImg];
  const titles = [
    ["MESSAGE", "인사말"],
    ["ORGANIZATION", "조직 현황"],
    ["HISTORY", "회사 연혁"],
  ];

  const Content = styled.div`
    width: 100%;
    height: fit-content;

    display: flex;
    flex-direction: column;
    gap: 40px;

    & img {
      width: 100%;
    }
  `;

  const TitleContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 10px;

    & > div:first-child {
      font-size: 22px;
      font-weight: lighter;
    }

    & > div:nth-child(2) {
      font-size: 28px;
      font-weight: bold;
    }

    & > div:nth-child(3) {
      height: 1px;
      width: 80px;
      border-bottom: solid 2px var(--color-blueblack);
    }
  `;

  const Cert = styled.div`
    margin-top: 50px;
  `;

  return (
    <Content>
      <TitleContainer>
        <div>{titles[id][0]}</div>
        <div>{titles[id][1]}</div>
        <div />
      </TitleContainer>
      <img src={cards[id]} alt={"1.png"} />
      {id === "2" ? (
        <Cert>
          <TitleContainer>
            <div>CERTIFICATION</div>
            <div>인증 및 특허</div>
            <div />
          </TitleContainer>
          <img src={CertImg} alt={"cert.jpg"} />
        </Cert>
      ) : (
        <></>
      )}
    </Content>
  );
}
